import React from 'react'
import { TabProps } from '@material-ui/core'
import Tab from '@material-ui/core/Tab'
import { createStyles, Theme, withStyles } from '@material-ui/core/styles'

const YumTab = withStyles((theme: Theme) =>
  createStyles({
    root: {
      //minHeight: '32px',
      minWidth: 'auto',
      textTransform: 'none',
      borderRadius: '8px',
      fontWeight: 600,
      fontSize: '13px',
      lineHeight: '16px',
      whiteSpace: 'nowrap',

      //padding: '4px 12px',
      minHeight: '28px',
    },
    textColorPrimary: {
      color: theme.palette.text.primary,
    },
    selected: {
      //color: 'white !important',
      //backgroundColor: 'white',
    },
    wrapper: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      display: 'block',
    },
  }),
)(({ classes, ...props }: TabProps) => {
  return <Tab classes={classes} {...props} />
})

export default YumTab
